import { render, staticRenderFns } from "./QnaClsForm.vue?vue&type=template&id=15011a1c&"
import script from "./QnaClsForm.vue?vue&type=script&lang=js&"
export * from "./QnaClsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports